<template>
  <PlatformLayout :layout-class="layoutClass" title="Поиск программ">
    <ProgramsSearchPage />
  </PlatformLayout>
</template>

<script>
import PlatformLayout from '@/components/platform/PlatformLayout.vue';
import ProgramsSearchPage from '@/components/programs/ProgramsSearchPage.vue';
import 'vue-awesome-paginate/dist/style.css';

export default {
  components: {
    PlatformLayout,
    ProgramsSearchPage,
  },
  computed: {
    layoutClass() {
      if (['curator', 'expert'].includes(this.$store.state.role)) return 'mainStyle';
      if (['supervisor', 'chief'].includes(this.$store.state.role)) return 'mainStyle3';
      return 'mainStyle1';
    },
  },
};
</script>
